import Global from "@/Global.js";
import { businessPost, businessPost2 } from "@/api/business";
import axios from "axios";

export function utilsCleanUserInfo() {
  localStorage.removeItem(Global.GlobalLocalToken);
  localStorage.removeItem(Global.GlobalLocalUserMsg);
  // if (localStorage.getItem("selectedGroupId")) {
  //   localStorage.removeItem("selectedGroupId");
  // }
  if (localStorage.getItem("selectedName")) {
    localStorage.removeItem("selectedName");
  }
}

export function utilsIsAlipayOrWechat() {
  // const userAgent = window.navigator.userAgent.toLowerCase();
  // const isAlipay = userAgent.includes('alipay') && !userAgent.includes('chrome'); // 假设Chrome的用户代理也包含'alipay'，但不是支付宝环境
  // const isWechat = userAgent.includes('micromessenger');
  // if (isAlipay) {
  //     return "alipay";
  // }
  // else if (isWechat) {
  //     return "wechat";
  // }
  // else {
  //     return "";
  // }

  let msg = "";
  if (/MicroMessenger/.test(window.navigator.userAgent)) {
    msg = "wechat";
  } else if (/AlipayClient/.test(window.navigator.userAgent)) {
    msg = "alipay";
  }
  return msg;

  // return 'alipay';
}

export function publicListQuery(list, val, valName = "value") {
  if (!Array.isArray(list)) {
    throw new TypeError('Expected an array for the "list" parameter');
  }
  for (const item of list) {
    if (item[valName] === val) {
      return item;
    }
  }
  return null;
}

export function utilsLogInAgain() {
  // let url = '';
  // let companyMsg = JSON.parse(localStorage.getItem(Global.GlobalLocalCompanyMsg));
  // url = window.location.origin + window.location.pathname + '#/HomeAuth?companyId=' + companyMsg.companyId;
  // let nextPageMsg = localStorage.getItem(Global.GlobalLocalNextPageMsg)
  // if (nextPageMsg) {
  //   url = url + '&nextPage=' + encodeURIComponent(JSON.parse(nextPageMsg).url)
  // }
  // let externalSource = localStorage.getItem(Global.GlobalLocalExternalSource)
  // if (externalSource) {
  //   url = url + '&externalSource=' + encodeURIComponent(externalSource)
  // }
  // let h5Environment = utilsIsAlipayOrWechat();
  // if (h5Environment == 'wechat') {
  //   window.location.href = url;
  // }
  // else if (h5Environment == 'alipay') {
  //   let openid = localStorage.getItem(Global.GlobalLocalOpenId);
  //   url = url + '&openId=' + openid;
  //   window.location.href = url;

  //   // window.my.postMessage({ loginAgain: 1 });
  // }

  let url = window.location.origin + window.location.pathname + "#/loginMobile";
  window.location.href = url;
}
export function utilsMaintainJump() {
  let url =
    window.location.origin + window.location.pathname + "#/maintainView";
  window.location.href = url;
}

export function utilsHideWXCopyUrl() {
  function onBridgeReady() {
    window.WeixinJSBridge.call("hideOptionMenu");
  }
  if (typeof window.WeixinJSBridge == "undefined") {
    if (document.addEventListener) {
      document.addEventListener("WeixinJSBridgeReady", onBridgeReady, false);
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
      document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
    }
  } else {
    onBridgeReady();
  }
}

export function utilsBurialPointRequest(val) {
  return new Promise((resolve) => {
    let url = "/system/point";
    let data = {
      type: val,
    };
    let companyMsg = localStorage.getItem(Global.GlobalLocalCompanyMsg);
    if (companyMsg) {
      data.deptId = JSON.parse(companyMsg).companyId;
    }
    let userMsg = localStorage.getItem(Global.GlobalLocalUserMsg);
    if (userMsg) {
      data.userId = JSON.parse(userMsg).userId;
    }
    let h5Environment = utilsIsAlipayOrWechat();
    if (localStorage.getItem(Global.GlobalLocalExternalSource)) {
      data.origin = localStorage.getItem(Global.GlobalLocalExternalSource);
      if (
        localStorage.getItem(Global.GlobalLocalExternalSource) == "reservation"
      ) {
        if (h5Environment == "wechat") {
          data.origin = 1;
        } else if (h5Environment == "alipay") {
          data.origin = 0;
        }
      }
    } else {
      if (h5Environment == "wechat") {
        data.origin = 3;
      } else if (h5Environment == "alipay") {
        data.origin = 2;
      }
    }
    businessPost(url, data).then((res) => {
      resolve(res);
    });
  });
}

export function utilsGenerateRandomString(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < length; i++) {
    var randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }
  return result;
}

export function utilsAllFiles() {
  let result = [
    {
      id: 1,
      name: "右脚触地",
      frameNumber: 51,
      imgUrl: "./file/fbx/poses/右脚触地/000051.jpg",
      amaModelFileUrl: "./file/fbx/poses/右脚触地/ama_51.fbx",
      amaJsonFileUrl: "./file/fbx/poses/右脚触地/ama_51.json",
      proModelFileUrl: "./file/fbx/poses/右脚触地/pro_59.fbx",
      proJsonFileUrl: "./file/fbx/poses/右脚触地/pro_59.json",
      aiVideo: "./file/fbx/poses/右脚触地/wz_run_state_51.mp4",
    },
    {
      id: 2,
      name: "右腿蹬伸",
      frameNumber: 56,
      imgUrl: "./file/fbx/poses/右腿蹬伸/000056.jpg",
      amaModelFileUrl: "./file/fbx/poses/右腿蹬伸/ama_56.fbx",
      amaJsonFileUrl: "./file/fbx/poses/右腿蹬伸/ama_56.json",
      proModelFileUrl: "./file/fbx/poses/右腿蹬伸/pro_87.fbx",
      proJsonFileUrl: "./file/fbx/poses/右腿蹬伸/pro_87.json",
      aiVideo: "./file/fbx/poses/右腿蹬伸/wz_run_state_56.mp4",
    },
    {
      id: 3,
      name: "右腿中立",
      frameNumber: 89,
      imgUrl: "./file/fbx/poses/右腿中立/000089.jpg",
      amaModelFileUrl: "./file/fbx/poses/右腿中立/ama_89.fbx",
      amaJsonFileUrl: "./file/fbx/poses/右腿中立/ama_89.json",
      proModelFileUrl: "./file/fbx/poses/右腿中立/pro_101.fbx",
      proJsonFileUrl: "./file/fbx/poses/右腿中立/pro_101.json",
      aiVideo: "./file/fbx/poses/右腿中立/wz_run_state_89.mp4",
    },
    {
      id: 4,
      name: "左脚触地",
      frameNumber: 60,
      imgUrl: "./file/fbx/poses/左脚触地/000060.jpg",
      amaModelFileUrl: "./file/fbx/poses/左脚触地/ama_60.fbx",
      amaJsonFileUrl: "./file/fbx/poses/左脚触地/ama_60.json",
      proModelFileUrl: "./file/fbx/poses/左脚触地/pro_69.fbx",
      proJsonFileUrl: "./file/fbx/poses/左脚触地/pro_69.json",
      aiVideo: "./file/fbx/poses/左脚触地/wz_run_state_60.mp4",
    },
    {
      id: 5,
      name: "左腿蹬伸",
      frameNumber: 47,
      imgUrl: "./file/fbx/poses/左腿蹬伸/000047.jpg",
      amaModelFileUrl: "./file/fbx/poses/左腿蹬伸/ama_47.fbx",
      amaJsonFileUrl: "./file/fbx/poses/左腿蹬伸/ama_47.json",
      proModelFileUrl: "./file/fbx/poses/左腿蹬伸/pro_96.fbx",
      proJsonFileUrl: "./file/fbx/poses/左腿蹬伸/pro_96.json",
      aiVideo: "./file/fbx/poses/左腿蹬伸/wz_run_state_47_1.mp4",
    },
    {
      id: 6,
      name: "左腿中立",
      frameNumber: 80,
      imgUrl: "./file/fbx/poses/左腿中立/000080.jpg",
      amaModelFileUrl: "./file/fbx/poses/左腿中立/ama_80.fbx",
      amaJsonFileUrl: "./file/fbx/poses/左腿中立/ama_80.json",
      proModelFileUrl: "./file/fbx/poses/左腿中立/pro_92.fbx",
      proJsonFileUrl: "./file/fbx/poses/左腿中立/pro_92.json",
      aiVideo: "./file/fbx/poses/左腿中立/wz_run_state_80.mp4",
    },
  ];
  return result;
}

//获取数组中最大最小值
export function utilsArrayGetMaxMin(sort, list) {
  let data = null;
  if (sort == "max") {
    data = Math.max.apply(null, list);
  } else if (sort == "min") {
    data = Math.min.apply(null, list);
  }
  if (data) {
    let index = list.findIndex((num) => num === data);
    let msg = {
      data: data,
      index: index,
    };
    return msg;
  }
  return null;
}

export function utilsReadJsonData(jsonUrl) {
  return new Promise((resolve) => {
    fetch(jsonUrl)
      .then((response) => response.json())
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });
}

export function utilsListQuery(list, val, valName = "value") {
  if (!Array.isArray(list)) {
    throw new TypeError('Expected an array for the "list" parameter');
  }
  for (const item of list) {
    if (item[valName] === val) {
      return item;
    }
  }
  return null;
}

// 帧数转时间
export function utilsCalculationTime(num, fps = 30, sort) {
  // console.log("计算参数", num, fps, sort);
  // let frameDuration = 1 / fps;
  // let frameNumber = num - 1;//想要跳转到的帧编号
  // let consttargetTime = frameNumber * frameDuration; //计算对应的时间
  // let consttargetTime = num / fps
  let consttargetTime = num / fps - 0.01;
  // console.log("consttargetTime计算结果", consttargetTime);
  if (sort && sort == 1) {
    consttargetTime = consttargetTime.toFixed(2) + "秒";
    return consttargetTime;
  } else {
    return consttargetTime;
  }
  // dp.seek(consttargetTime);
}
export function utilsCalculationTime2(num, fps = 30, sort) {
  let consttargetTime = num / fps;
  if (sort && sort == 1) {
    consttargetTime = consttargetTime.toFixed(2) + "秒";
    return consttargetTime;
  } else {
    return consttargetTime;
  }
}
export function utilsCalculationTime3(num, total, time) {
  let consttargetTime = (num / total) * time;
  return consttargetTime;
}

// 判断地址
export function utilsJudgmentVideoUrl(url) {
  return new Promise((resolve) => {
    const videoUrl = url;
    axios
      .get(videoUrl)
      .then((response) => {
        const statusCode = response.status;
        if (statusCode === 200) {
          // console.log('视频存在');
          resolve(1);
        } else if (statusCode === 404) {
          // console.log('视频不存在');
          resolve(2);
        } else {
          // console.log('发生错误，状态码：', statusCode);
          resolve(2);
        }
      })
      .catch(() => {
        // console.log('发生错误：', error);
        resolve(2);
      });
  });
}

//日期转换为 2024-5-15 > 15 May
export function utilsReturnEngDate(dateStr) {
  // 创建一个 Date 对象
  const date = new Date(dateStr);
  // 获取日期中的日
  const day = date.getDate();
  // 创建一个数组，存储每个月对应的英文名称
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  // 根据月份索引从数组中获取对应的英文名称
  const month = monthNames[date.getMonth()];
  // 截取英文月份名称的前 3 个字符，实现缩写
  const shortMonth = month.slice(0, 3);
  // 将日和缩写后的月份拼接成最终格式
  return `${day} ${shortMonth}`;
}

// 获取文件二进制流
export function utilsGetFileBinary(type, msg) {
  return new Promise((resolve) => {
    let url = "/system/video/down";
    let data = {
      type: type,
    };
    if (type == 1) {
      data.id = msg.id;
      data.orderNum = msg.orderNum;
    } else if (type == 3) {
      data.id = msg.id;
    } else if (type == 4) {
      data.fbx = msg.fbx;
    } else if (type == 5) {
      data.id = msg.id;
      data.fbx = msg.fbx;
    } else if (type == 6) {
      data.id = msg.id;
    } else if (type == 7) {
      data.id = msg.id;
    } else if (type == 8) {
      data.userId = msg.userId;
    } else if (type == 9) {
      data.id = msg.id;
    } else if (type == 11) {
      data.url = msg.url;
    }
    if (type == 3) {
      businessPost(url, data).then((res) => {
        // console.log("获取json二进制流", res);
        resolve(res);
      });
    } else {
      businessPost2(url, data)
        .then((res) => {
          let blob = null;
          if (type == 6 || type == 7) {
            blob = new Blob([res], { type: "video/mp4" });
          } else {
            blob = new Blob([res], { type: "application/octet-stream" });
          }
          let objectURL = URL.createObjectURL(blob);
          resolve(objectURL);
        })
        .catch((error) => {
          console.log("获取文件二进制流错误", error);
        });
    }
  });
}

// 判断是不是VIP 0不是1是 null无法判断
export function utilsJudgmentVIP() {
  let userMsg = localStorage.getItem(Global.GlobalLocalUserMsg);
  // console.log(userMsg)
  if (userMsg && "isVip" in JSON.parse(userMsg)) {
    return JSON.parse(userMsg).isVip;
  }
  return null;
}
